import React, { useContext, useEffect, useState } from 'react';
import { ScreensContext } from '../contexts/screensContext';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import HomeScreen from '../components/26ua-kv2/home-screen';
import WelcomeAgeVerificationScreen from '../components/ua-brand/welcome-age-verification-screen';
import FaceCaptureScreen from '../components/ua-brand/face-capture-screen';
import YoungAgeScreen from '../components/ua-brand/young-age-screen';
import WelcomeFormScreen from '../components/ua-brand/welcome-form-screen';
import FormScreen from '../components/ua-brand/form-screen';
import OtpScreen from '../components/ua-brand/otp-screen';
import AlreadyRegistered from '../components/promoter/already-registered';
import SuccessRegistered from '../components/promoter/success-registered';
import AttemptsExhausted from '../components/ua-brand/attempts-exhausted';
import useScreenHistory from '../hooks/useScreenHistory';

const utm_campaign = sessionStorage.getItem('utm_campaign');

const KV2UA26 = () => {
  const [formData, setFormData] = useState({});
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 5
  });
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const telegramLink = `https://t.me/pmu_support_bot?start=ScnPck-${utm_campaign}`;

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('26UA-KV2');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 5: {
        return (
          <WelcomeAgeVerificationScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1, true)}
            handleNextVerificationScreen={() => setScreenNumber(6)}
          />
        );
      }
      case 6: {
        return (
          <FaceCaptureScreen
            setScreenNumber={setScreenNumber}
            onSuccessFlow={() => setScreenNumber(8.1)}
          />
        );
      }
      case 7: {
        return (
          <YoungAgeScreen backButtonClick={() => setScreenNumber(6, true)} />
        );
      }
      case 8.1: {
        return <HomeScreen onTakeSurvey={() => setScreenNumber(8)} />;
      }
      case 8: {
        return (
          <WelcomeFormScreen
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => {
              sendEvent('registration');
              setScreenNumber(9);
            }}
            isHideSkipButton
            telegramLink={telegramLink}
          />
        );
      }
      case 9: {
        return (
          <FormScreen
            utm_campaign={utm_campaign}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(8, true)}
            telegramLink={telegramLink}
            setFormData={(data) => setFormData(data)}
            formData={formData}
            isPromoter
          />
        );
      }
      case 10: {
        return (
          <OtpScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            handleChangePhoneNumber={() => setScreenNumber(9)}
            successSendOtp={() => {
              sendEvent('passed_authorization');
              setScreenNumber(12);
            }}
            attemptsExhaustedChangeScreen={() => setScreenNumber(15)}
          />
        );
      }
      case 11: {
        return <AlreadyRegistered telegramLink={telegramLink} />;
      }
      case 12: {
        return <SuccessRegistered telegramLink={telegramLink} />;
      }
      case 15: {
        return (
          <AttemptsExhausted
            setScreenNumber={setScreenNumber}
            checkPhoneNumber={() => setScreenNumber(9)}
            telegramLink={telegramLink}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };
  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default KV2UA26;
